import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const campusesAdapter = getAdapter({ idFieldName: 'value' });

const campusesSlice = createSlice({
  name: 'campuses',
  initialState: campusesAdapter.getInitialState(),
  reducers: {
    setCampuses: (state, { payload: { campuses } }) => {
      campusesAdapter.setAll(state, campuses);
    },
  },
});

const selectors = campusesAdapter.getSelectors(({ campuses }) => campuses);

export const getCampuses = (state) => selectors.selectAll(state);

export const {
  setCampuses,
} = campusesSlice.actions;

export default campusesSlice.reducer;